import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { CustomButton } from '../../Button';
import styles from '../styles';
import { useHistory } from 'react-router-dom';
import BillingForm from '../BillingForm';
import {
  Typography, Box, FormControl, FormControlLabel, Checkbox, Link
} from '@material-ui/core';
import IbanField from './IbanField';
import RenewableChoiceField from './RenewableChoiceField';

// Fonction pour ajouter le protocole si nécessaire
const addProtocol = (url) => {
  if (!/^https?:\/\//i.test(url)) {
    return `https://${url}`;
  }
  return url;
};

const DirectDebitForm = (props) => {
  const classes = styles();
  const history = useHistory();
  const { doPaymentLoading } = useSelector((state) => ({
    doPaymentLoading: state.getIn(['app', 'doPaymentLoading'])
  }));

  const [renewableChoice, setRenewableChoice] = useState('recurring'); // valeur initiale par défaut
  const [agreeTerms, setAgreeTerms] = useState(false);
  const handleSubmit = () => {
    props.handleSubmit();
  };

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
    >
      <Grid
        item
        container
        direction={{ xs: 'column', sm: 'row' }}
        alignItems="flex-start"
        className={classes.customSameContainerIban}
      >
        <BillingForm props={props} />
        <Grid
          item
          container
          direction="column"
          alignItems="center"
          className={classes.formContainer}
          xs={12}
          sm={6}
        >
          <Typography variant="h3" className={classes.title}>PRÉLÈVEMENT</Typography>
          <Box>
            <IbanField />
          </Box>
        </Grid>
      </Grid>
      <RenewableChoiceField setFieldValue={props.setFieldValue} setRenewableChoice={setRenewableChoice} renewableChoice={renewableChoice} />
      <Grid
        item
        xs={12}
        className={classes.optionsContainer}
      >
        <FormControl component="fieldset">
          <FormControlLabel
            control={
              <Checkbox
                checked={agreeTerms}
                onChange={(e) => setAgreeTerms(e.target.checked)}
                name="agreeTerms"
              />
            }
            label={
              <span>
                J'accepte les {" "}
                <Link
                  href={`${addProtocol(process.env.REACT_APP_URL_PUBLIC_SITE)}/legal`}
                  target="_blank"
                  rel="noreferrer noopener"
                  className={classes.navLink}
                >
                  termes et conditions
                </Link>
              </span>
            }
          />
        </FormControl>
      </Grid>
      <Grid
        item
        container
        direction="row"
        className={classes.buttonContainer}
      >
        <CustomButton
          variant="contained"
          color="secondary"
          handleClick={() => history.push('/')}
          title="Annuler"
        />
        <CustomButton
          type="submit"
          variant="contained"
          color="primary"
          handleClick={() => handleSubmit()}
          disabled={!agreeTerms}
          loading={doPaymentLoading}
          title="Adhérer"
        />
      </Grid>
    </Grid>
  );
};

export default DirectDebitForm;
